import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tvShows';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                  <span className="text-background-50 font-heading font-bold text-base">97</span>
                </div>
                <span className="text-foreground-950 font-heading font-bold text-lg">97影院</span>
              </Link>
              <p className="text-foreground-400 text-sm leading-relaxed">
                高清蓝光不卡顿，热门电视剧全集免费在线观看。每日更新最新剧集，追剧首选平台。
              </p>
            </div>
            <div>
              <h4 className="text-foreground-900 font-semibold text-sm mb-4">影视分类</h4>
              <div className="flex flex-col gap-2">
                {categories.filter(c => c.slug !== 'all').slice(0, 4).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-foreground-900 font-semibold text-sm mb-4">热门推荐</h4>
              <div className="flex flex-col gap-2">
                <Link to="/detail/1" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">长风渡</Link>
                <Link to="/detail/2" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">狂飙</Link>
                <Link to="/detail/3" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">黑暗荣耀</Link>
                <Link to="/detail/13" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">繁花</Link>
              </div>
            </div>
            <div>
              <h4 className="text-foreground-900 font-semibold text-sm mb-4">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">品牌介绍</Link>
                <a href="#" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
                <a href="#" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
                <a href="#" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">版权声明</a>
              </div>
            </div>
          </div>
          <div className="pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-400 text-xs">
              &copy; 2024 97影院 97yingyuan.com - 本站所有资源均来源于互联网，仅供学习交流之用
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}